import { BREAKPOINT_SP } from '~/common/config'
import { isSP } from '~/common/utils'
import { next } from '~/common/utils'
import Events from '~/common/Events'
import { slideDown, slideUp, slideStop } from 'slide-anim'

const HEADER = 'header'
const NAV = '.js-nav'
const SLIDE_NAV = '.js-slide-nav'
const NAV_TRIGGER = '.js-nav-trigger'
const SLIDE_TRIGGER = '.js-slide-trigger'
const CLASS_OPEN = '-open'

/**
 * @export
 * @class Navigation
 */
export default class Navigation {

  constructor() {
    this.windowState = window.innerWidth >= BREAKPOINT_SP ? 'PC' : 'SP'
    this.header = document.getElementById(HEADER)
    this.nav = document.querySelectorAll(NAV)
    this.slideNav = document.querySelectorAll(SLIDE_NAV)
    this.trigger = document.querySelectorAll(NAV_TRIGGER)
    this.slideTrigger = document.querySelectorAll(SLIDE_TRIGGER)

    this.eventHandler()
  }

  eventHandler() {
    ;[...this.trigger].map(el => {
      el.addEventListener('click', _el => {
        _el.preventDefault()
        const openState = el.classList.contains(CLASS_OPEN)
        return !openState ? this.open(_el) : this.close(_el)
      })
    })

    // メガメニューの開閉
    ;[...this.slideTrigger].map(el => {
      el.addEventListener('click', _el => {
        _el.preventDefault()
        if (isSP()) {
          const openState = el.classList.contains(CLASS_OPEN)
          return !openState ? this.open(_el) : this.close(_el)
        }
      })
    })

    // 固定ナビを横スクロールできるようにする
    window.addEventListener('scroll', () => {
      const docScrollLeft = document.documentElement.scrollLeft
      if (!isSP()) {
        this.header.setAttribute('style', `left: -${docScrollLeft}px;`)
      }
    }, false)

    window.addEventListener('resize', () => {
      this.resizeReset()
    })

    // カスタムイベント登録
    Events.on('NAV_CLOSE', () => {
      this.close()
    })
  }

  open(_el) {
    const trigger = _el.currentTarget
    trigger.classList.add(CLASS_OPEN)
    this.header.classList.add(CLASS_OPEN)

    if (trigger === this.trigger[0]) {
      ;[...this.nav].map(el => {
        el.classList.add(CLASS_OPEN)
      })
    }

    if (trigger.classList.contains(SLIDE_TRIGGER.slice(1))) {
      const nextSlideNav = next(trigger)
      slideStop(nextSlideNav)
      slideDown(nextSlideNav, {
        display: 'flex'
      })
    }
  }

  close(_el) {
    if (!_el) {
      if (isSP()) {
        this.header.classList.remove(CLASS_OPEN)
        this.header.scrollTop = 0
        this.nav[0].classList.remove(CLASS_OPEN)
        this.trigger[0].classList.remove(CLASS_OPEN)

        ;[...this.slideTrigger].map(el => {
          el.classList.remove(CLASS_OPEN)
          const nextSlideNav = next(el)
          slideStop(nextSlideNav)
          slideUp(nextSlideNav)
        })
      }
    }

    else {
      const trigger = _el.currentTarget
      trigger.classList.remove(CLASS_OPEN)

      if (trigger === this.trigger[0]) {
        this.header.classList.remove(CLASS_OPEN)

        ;[...this.nav].map(el => {
          el.classList.remove(CLASS_OPEN)
        })
      }

      if (trigger.classList.contains(SLIDE_TRIGGER.slice(1))) {
        const nextSlideNav = next(trigger)
        slideStop(nextSlideNav)
        slideUp(nextSlideNav)
      }
    }
  }

  // リサイズ時に状態を初期に戻す
  resizeReset() {
    // SP → PCにリサイズされた時
    if (!window.matchMedia(`(max-width:${BREAKPOINT_SP}px)`).matches && this.windowState !== 'PC') {
      this.header.classList.remove(CLASS_OPEN)
      this.header.scrollTop = 0
      this.nav[0].classList.remove(CLASS_OPEN)
      this.trigger[0].classList.remove(CLASS_OPEN)

      this.windowState = 'PC'
     }

    // PC → SPにリサイズされた時
    if (window.matchMedia(`(max-width:${BREAKPOINT_SP}px)`).matches && this.windowState !== 'SP') {
      this.header.setAttribute('style', 'left: 0;')
      this.header.scrollTop = 0

      this.windowState = 'SP'
    }
  }
}